export default __webpack_public_path__ + "static/imgVideoBanner-6ba549a7de416cc0b1afec160cd7a469.png";